export default function DashboardOverlays({
  notification,
  onHideNotification,
  popupState,
  onClosePopup,
  onPopupInputChange,
}) {
  return (
    <>
      {notification.show && (
        <div className={`custom-notification custom-notification-${notification.type}`}>
          <div className="notification-content">
            <div className="notification-message">
              {notification.message.split('\n').map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
            <button
              className="notification-close"
              onClick={onHideNotification}
              title="Close notification"
              type="button"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {popupState.open && (
        <div className="od-popup-overlay" onClick={() => onClosePopup(false)}>
          <div
            className={`od-popup-card od-popup-${popupState.type}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="od-popup-title">{popupState.title || 'Notice'}</div>
            <div className="od-popup-message">
              {popupState.message.split('\n').map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
            </div>
            {popupState.mode === 'prompt' && (
              <input
                className="od-popup-input"
                value={popupState.inputValue}
                onChange={(e) => onPopupInputChange(e.target.value)}
                autoFocus
              />
            )}
            <div className="od-popup-actions">
              {popupState.mode !== 'alert' && (
                <button
                  type="button"
                  className="od-popup-btn od-popup-btn-cancel"
                  onClick={() => onClosePopup(false)}
                >
                  {popupState.cancelText || 'Cancel'}
                </button>
              )}
              <button
                type="button"
                className="od-popup-btn od-popup-btn-confirm"
                onClick={() => {
                  if (popupState.mode === 'confirm') onClosePopup(true);
                  else if (popupState.mode === 'prompt') onClosePopup(popupState.inputValue);
                  else onClosePopup(true);
                }}
              >
                {popupState.confirmText || 'OK'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
